module.exports = __webpack_public_path__ + "img/ornament-circle-bottom.938d04d8.svg";